module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Night-rain-bffa09f89c0b271ec86e24793c4651b7.svg";